import { LazyPage } from '../../components/loadable';

export const MonHocPage = LazyPage(import('./sis_monhoc'))
export const ToKhoiPage = LazyPage(import('./sis_tokhoi'));
export const GiaoVienPage = LazyPage(import('./sis_giaovien'))
export const TuanPage = LazyPage(import('./pl_tuan'));
export const TietPage = LazyPage(import('./pl_tiet'));
export const HocKyPage = LazyPage(import('./pl_hocky'));
export const PhongHocPage = LazyPage(import('./pl_phonghoc'));
export const LoaiPhongHocPage = LazyPage(import('./pl_loaiphong'));